// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"615":"45f7ca3b","725":"8ac8726a"}[chunkId] + ".chunk.js";
};